import {Box, Center, Link} from '@chakra-ui/react';
import {LeftChevronIcon} from '@eksab/assets/icons';
import {px} from '@eksab/theme';
import {Match} from '.';
import {useGameQuery} from '../hooks';
import NextLink from 'next/link';
import {useRouter} from 'next/router';

export function MatchHeader({gameId}: {gameId: string}) {
  const gameQuery = useGameQuery({game: gameId}, 'participant');
  const router = useRouter();
  const backUrl = router.asPath.split('/').slice(0, -1).join('/');
  return (
    <Box minH="70px" px={px} bgColor="gray.600" alignSelf="stretch" display="flex" alignItems="center">
      <Center pos="relative" flex="1">
        <NextLink passHref href={backUrl} legacyBehavior>
          <Link pos="absolute" insetStart={0}>
            <LeftChevronIcon />
          </Link>
        </NextLink>
        {gameQuery.data?.match && <Match match={gameQuery.data?.match} px={[3, null, 12]} />}
      </Center>
    </Box>
  );
}
